<script setup>
import { computed } from 'vue';
import CardTaskHeader from './CardTaskHeader.vue';
import { canScheduleVisit, shownTask } from '../visitTask';

// One task's row as the card page and the task bubble show it. A visit request shows, and works,
// the visit it was scheduled into; until then its status stands out, since finishing the request
// is scheduling it: picking "Agendada" opens the scheduling dialog.
const props = defineProps({
  task: { type: Object, required: true },
  agents: { type: Array, required: true },
  // Only the card page deletes tasks; the conversation's bubble never does.
  deletable: { type: Boolean, default: false },
});

// `update`, `status` and `delete` name the task they apply to: the task itself or its visit.
const emit = defineEmits(['update', 'status', 'schedule', 'delete']);

const shown = computed(() => shownTask(props.task));
const isSchedulable = computed(() => canScheduleVisit(props.task));

const onStatus = transition => {
  if (isSchedulable.value && transition === 'complete') emit('schedule');
  else emit('status', shown.value, transition);
};
</script>

<template>
  <CardTaskHeader
    :task="shown"
    :agents="agents"
    :prominent-status="isSchedulable"
    :deletable="deletable"
    @update="attributes => emit('update', shown, attributes)"
    @status="onStatus"
    @delete="emit('delete', shown)"
  />
</template>
